import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "17",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.343 1.436c-.657 0-1.197.54-1.197 1.196v11.486c0 .656.54 1.196 1.197 1.196h15.314c.657 0 1.197-.54 1.197-1.196V2.632c0-.656-.54-1.196-1.197-1.196H3.343ZM.71 2.632A2.638 2.638 0 0 1 3.343 0h15.314a2.638 2.638 0 0 1 2.632 2.632v11.486a2.638 2.638 0 0 1-2.632 2.632H3.343A2.638 2.638 0 0 1 .71 14.118V2.632Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.84 2.22a.718.718 0 0 1 1-.176L11 8.456l9.16-6.412a.718.718 0 1 1 .823 1.176l-9.571 6.7a.718.718 0 0 1-.824 0l-9.571-6.7a.718.718 0 0 1-.177-1Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }